import ApiRequest from 'EurestoApi/ApiRequest'
import Constants from 'EurestoFonction/Constants'

const project = require('EurestoConfig/project.config')

let User = (() => {
  let info = ''


  let isConnectedAs = _ => {
    return (info.type === Constants.access.EURESTO && Entite.get().type !== Constants.access.EURESTO) ||
      (info.type === Constants.access.USER_GROUPE && Entite.get().type !== Constants.access.GROUPE) ||
      (info.type === Constants.access.USER_ETS && Entite.get().type !== Constants.access.ETABLISSEMENT)
  }

  let get = () => {
    return info
  }

  let set = (t) => {
    info = t
  }

  return {
    get: get,
    set: set,
    isConnectedAs: isConnectedAs
  }
})()

let Entite = (() => {
  let info = ''

  let get = () => {
    return info
  }

  let set = (t) => {
    info = t
  }

  return {
    get: get,
    set: set
  }
})()

let Droits = (() => {
  let droits = []

  let isAllow = (t) => {
    return droits.indexOf(t) > -1
  }

  let list = () => {
    return droits
  }

  let set = (t) => {
    droits = t
  }

  let add = (t) => {
    droits.push(t)
  }

  let rm = (t) => {
    let pos = droits.indexOf(t)
    if (pos > -1) {
      droits.splice(pos, 1)
    }
  }

  return {
    isAllow: isAllow,
    list: list,
    set: set,
    add: add,
    rm: rm
  }
})()

let Configurations = (() => {
  let configurations = []

  let list = () => {
    return configurations
  }

  let get = (t) => {
    return configurations.find(obj => {
      let val = Object.keys(t).map((key) => (obj[key] === t[key]))
      return val.indexOf(false) === -1
    })
  }

  let set = (t) => {
    configurations = t
  }

  let add = (t) => {
    configurations.push(t)
  }

  let rm = (t) => {
    let pos = configurations.indexOf(t)
    if (pos > -1) {
      configurations.splice(pos, 1)
    }
  }

  return {
    list: list,
    get: get,
    set: set,
    add: add,
    rm: rm
  }
})()

let isAddUpdateDeleteAvaibleForMe = () => {
  return true
}

let Connect = (() => {
  let go = async (key) => {
    let token = ''
    const sessionTokenResult = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'token',
      key: key
    })
    if (sessionTokenResult.code === 1) {
      //console.log(sessionTokenResult.token)
      //localStorage.setItem('token', sessionTokenResult.token)
      token = sessionTokenResult.token
      //window.open('/?isConnectedAs=true&token=' + sessionTokenResult.token, '_blank')
    }
    return token
  }

  return {
    go: go,
  }
})()

let Disconnect = (() => {
  let cb

  let set = (t) => {
    cb = t
  }

  let get = () => {
    Entite.set({})
    User.set({})
    cb()
  }

  return {
    get: get,
    set: set,
  }
})()



let ColorWebSite = (() => {
  let cb

  let init = (t) => {
    cb = t
  }

  let change = () => {
    let themeUser = Constants.themeUI[User.get().theme_id]
    if (themeUser === undefined) {
      themeUser = 'default'
    }
    let wrapper = $('.wrapper')
    wrapper.attr('class', 'wrapper')
    wrapper.attr('class', 'wrapper ' + themeUser)
    cb()
  }

  return {
    init: init,
    change: change,
  }
})()

let TypeAccess = (() => {

  let get = (access) => {
    return (access === Entite.get().type)
  }

  return {
    get: get,
  }
})()

let VinistoriaCRM = (() => {
  let get = () => {
    return Entite.get().vinistoria_crm === 1 || false
  }

  return {
    get: get,
  }
})()

let ContactIdRegisterCallBack = (() => {
  let cbGet = []
  let cbDossier = []
  let cbAction = []
  let cbFichier = []

  let set = (cb) => {
    if (cb.get !== undefined) {
      cbGet.push(cb.get)
      cb.get = cbGet.length - 1
    }
    if (cb.dossier !== undefined) {
      cbDossier.push(cb.dossier)
      cb.dossier = cbDossier.length - 1
    }
    if (cb.action !== undefined) {
      cbAction.push(cb.action)
      cb.action = cbAction.length - 1
    }
    if (cb.fichier !== undefined) {
      cbFichier.push(cb.fichier)
      cb.fichier = cbFichier.length - 1
    }

    return cb
  }

  let reset = cb => {
    if (cb.get !== undefined) {
      cbGet.splice(cb.get, 1)
    }
    if (cb.dossier !== undefined) {
      cbDossier.splice(cb.dossier, 1)
    }
    if (cb.action !== undefined) {
      cbAction.splice(cb.action, 1)
    }
    if (cb.fichier !== undefined) {
      cbFichier.splice(cb.i, 1)
    }
  }

  let getCbGet = () => {
    return cbGet
  }

  let getCbDossier = () => {
    return cbDossier
  }

  let getCbAction = () => {
    return cbAction
  }

  let getCbFichier = () => {
    return cbFichier
  }

  let resetAll = () => {
    cbGet = []
    cbDossier = []
    cbAction = []
    cbFichier = []
  }

  let resetAllFichier = () => {
    cbFichier = []
  }

  return {
    set: set,
    getCbGet: getCbGet,
    getCbDossier: getCbDossier,
    getCbAction: getCbAction,
    getCbFichier: getCbFichier,
    resetAll: resetAll,
    resetAllFichier: resetAllFichier,
    reset: reset
  }
})()

let CalculHeight = (() => {
  let navigation = true
  let connectedAs = false
  let setNavigation = (isNAvigation) => {
    navigation = isNAvigation
  }
  let setConnectedAs = (isNAvigation) => {
    connectedAs = isNAvigation
  }

  let getIsConnectedAs = () => {
    return connectedAs
  }

  let getHeightWanted = (height = 0, other = '') => {
    return 'calc((100vh ' + (navigation ? ' - 40px ' : '') + (connectedAs ? ' - 31px ' : '') + '- ' + height + 'px) ' + other + ')'
  }
  return {
    setConnectedAs: setConnectedAs,
    setNavigation: setNavigation,
    getHeightWanted: getHeightWanted,
    getIsConnectedAs: getIsConnectedAs
  }
})()

let NotificationSystem = (() => {
  let cb

  let set = (c) => {
    cb = c
  }

  let callback = (ns) => {
    if (cb !== undefined) {
      cb(ns)
    }
  }

  return {
    set: set,
    callback: callback
  }
})()


let OpenMenuBar = (() => {
  let isOpen = true

  let get = () => {
    return isOpen
  }

  let set = (t) => {
    isOpen = t
  }

  return {
    get: get,
    set: set
  }

})()

export default {
  Droits: Droits,
  User: User,
  Entite: Entite,
  Configurations: Configurations,
  OpenMenuBar: OpenMenuBar,
  Disconnect: Disconnect,
  Connect: Connect,
  isAddUpdateDeleteAvaibleForMe: isAddUpdateDeleteAvaibleForMe,
  TypeAccess: TypeAccess,
  ContactIdRegisterCallBack: ContactIdRegisterCallBack,
  CalculHeight: CalculHeight,
  NotificationSystem: NotificationSystem,
  VinistoriaCRM: VinistoriaCRM,
  ColorWebSite: ColorWebSite
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Class/User.js